export const IS_UNIVERSAL_PARTNER =
  window.location.hostname === "admin.virtuales.pro";
